import { PageLinks } from "./page-links";
export const index_name = process.env.GATSBY_ALGOLIA_INDEX_NAME;

export const currency = process.env.GATSBY_CURRENCY;
export const country = "London";
export const defaultArea = process.env.GATSBY_DEFAULT_AREA ? process.env.GATSBY_DEFAULT_AREA : "London";
export const defaultArea_Slug = defaultArea.toLowerCase().replace(/ /g,'-');

export const defaultArea_Newhomes = process.env.GATSBY_DEFAULT_AREA_NEWHOMES ? process.env.GATSBY_DEFAULT_AREA_NEWHOMES : "London";
export const defaultArea_Newhomes_Slug = defaultArea_Newhomes.toLowerCase().replace(/ /g,'-');

export const defaultResult_Link = "/find-a-property/";

export const valuation_thanks = `<p>We’ll be in touch shortly to arrange a suitable time for one of our KFH experts to visit and assess your property.<br /><br />Looking to buy a property? Browse listings <a href="/${PageLinks.property_for_sale}/">here</a>.</p>
<h4>Your KFH Account</h4>
<p>Receive a tailored report with up-to-date insights into your home’s value and the current market in your area.</p>`

export const apply_btn_text = "";

export const LettingsAdminEmail = false;
export const epdqID = '';
export const Default_Map_Position = { 
    lat: 55.9533,
    lng: -3.1883 
};

export const site_name = process.env.GATSBY_SITE_NAME;
export const site_url = process.env.GATSBY_SITE_URL;

export const hasMyaccount = (process.env.GATSBY_MYACCOUNT || null) === '1' ? true : false;
export const hasPropertyCloud = (process.env.GATSBY_ENABLE_PROPERTYCLOUD || null) === '1' ? true : false;
export const postCodeAddressAPI = "ncZgV7m79UipxWpivISlAw37900";

export const IsAllAgentReview = true;
export const Default_View = "List"
export const slider_count = 3;
export const news_slider_count = 3;
export const site_bviewing_agent_id = ""

export const search_result_sidebar = false;

export const SimilarProperty_FullWdth = true;

export const currency_converter = true;

export const branch_filter = true;

export const officeStyle = "List"

export const viewing_btn_text = "Enquire";

export const search_box_placeholder = "Enter a location";

export const footerVatDetails = "Kinleigh Folkard & Hayward is the trading name of Kinleigh Limited.<br />Registered in England & Wales.<br />Registered office: KFH House, 5 Compton Road, Wimbledon, SW19 7QA.<br />Registered company number: 913323. VAT Number: 647 8742 89.<br />Part of Lomond";

export const mortgage_text = "This calculator gives a rough estimate only and isn't a promise of any mortgage terms. Real rates and offers depend on your situation and the lender. It's always best to chat with a qualified mortgage adviser for accurate, personalised advice."

export const marketing_consent = `I agree to receive property-related news, updates and communications from ${process.env.GATSBY_SITE_NAME}. I understand I can unsubscribe at any time.`

export const Mail_Vars = {
    fb_link: "https://www.facebook.com/KFHEstateAgent/",
    insta_link: "https://www.instagram.com/kfhproperty/",
    linkedin_link: "https://uk.linkedin.com/company/kinleigh-folkard-&-hayward",
    company_phone: "02382 358580",
    available_time: "We're available from 9am - 6pm Monday to Thursday, 9am - 5:30pm Friday",
    address: "KFH House, 5 Compton Road, Wimbledon, SW19 7QA."
}

// export const PageLinks = {
//     about: "about-brandvaughan",
//     general_enquiry: "general-enquiry",
//     news_insight: `about-brandvaughan/insights`,
//     branch_finder: "about-brandvaughan/branch-finder",
//     area_cover: "about-brandvaughan/areas-we-cover",
//     branch_contact: "contact-us",
//     team_contact: "contact-us",
//     teams: "about-brandvaughan/meet-the-team",
//     request_valuation: "property-valuation",
//     privacy_policy: "privacy-policy",
//     book_a_viewing: "book-a-viewing",
//     book_a_valuation: "property-valuation/home-visit-valuation",
//     send_to_friend: "send-to-friend",
//     property_to_rent: "property/to-rent",
//     property_for_sale: "property/for-sale",
//     reviews: "about-brandvaughan/customer-reviews",
//     property_management: "landlords/property-management",
//     financial_services: `financial-services`
// }

export const PropertySearchURL = {
    residential: {
        sales:"/property/for-sale/",
        lettings:"/property/to-rent/",
        sold:"/property/sold/",
        newhomes: "/new-homes/for-sale/",
        newdevelopments: "/new-developments/for-sale/",
        investments: "/property-investments/for-sale/",
        students: "/property-students/to-rent/",
        collection: "/property-collection/for-sale/"
    },
    commercial: {
        sales:"/commercial-property/for-sale/",
        lettings:"/commercial-property/to-rent/",
    },
    auction: {
        sales:"/auctions/for-sale/"
    }
}

export const PropertyDetailsURL = {
    residential: {
        sales:"/property-for-sale/",
        lettings:"/property-to-rent/",
        newhomes:"/property-for-sale/",
        newdevelopments:"/new-developments-for-sale/"
    },
    commercial: {
        sales:"/commercial-property-for-sale/",
        lettings:"/commercial-property-to-rent/",
    },
    auction: {
        sales:"/auction-for-sale/"
    }
}

export const SearchTitle = {
    residential: {
        sales:"Properties for sale",
        lettings:"Properties to rent",
        sold:"Sold properties",
        newhomes:"New homes",
        newdevelopments:"New developments",
        investments: "Investment properties for sale",
        students:"Student properties for sale",
    },
    commercial: {
        sales:"Commercial properties for sale",
        lettings:"Commercial properties to rent",
    },
    auction: {
        sales:"Auction properties for sale"
    }
}

export const PopularSearch_Areas = [ 
    { value: "london", label: "London" },
    { value: "putney", label: "Putney" },
    { value: "notting-hill", label: "Notting hill" },
    { value: "kensington", label: "Kensington" }   
]

export const PopularSearch_Types = [ 
    { value: "house", label: "Houses" },
    { value: "apartment", label: "Apartments" },
    { value: "bungalow", label: "Bungalows" },
    { value: "maisonette", label: "Maisonettes" }   
]

export const sortByList = [ 
    { value: "Newest", label: "Newest" },
    { value: "HighestPrice", label: "Highest Price" },
    { value: "LowestPrice", label: "Lowest Price" },
    { value: "Oldest", label: "Oldest" },
]

export const SearchType = {
    sales:"For Sale",
    lettings:"To Rent",
    sold:"Sold",
    newhomes:"New homes",
    investments:"Investments",
    students:"Students",
    commercial_sales:"Commercial Sales",
    commercial_lettings:"Commercial Lettings",
    auction_sales:"Auctions",
    collection:"Exclusive",
    newdevelopments:"Developments",
}

export const FurnishedType = [    
    { value: '', label: 'Select type' },
    { value: 'furnished', label: 'Furnished' },
    { value: 'unfurnished', label: 'Unfurnished' },
    { value: 'part-furnished', label: 'Part furnished' },
]

export const DepartmentType = [
    { value: '', label: 'Select type' },
    { value: 'residential', label: 'Residential' },
    { value: 'commercial', label: 'Commercial' },
]

export const leadooPageSlot = {
    sell_property:"Sellers",
    landlords:"Landlords",
    sales:"Sale listings",
    lettings:"Rental listing",
    branch_finder:"Branch finder",
    general_enquiry:"General enquiry",
    valuation:"Valuation",
    home:"Valuation"
}
